import { Column, ColumnConfig } from '@ant-design/plots';
import { useQuery } from '@apollo/client';
import {
  GET_USER_COMPANY_AFFILIATION,
  UserRoleStatistics,
} from '@frontend/data-access';
import { Card } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';

const UsersByCompanyAffiliation = () => {
  const { t } = useTranslation('admin');
  const { data, loading } = useQuery<{
    userCompanyAffiliation: {
      withCompanies: number;
      withoutCompanies: number;
    };
  }>(GET_USER_COMPANY_AFFILIATION);
  const [stats, setStats] = useState<UserRoleStatistics[]>([]);

  useEffect(() => {
    if (data?.userCompanyAffiliation) {
      setStats([
        {
          count: data?.userCompanyAffiliation.withCompanies,
          role: t('company_user'),
        },
        {
          count: data?.userCompanyAffiliation.withoutCompanies,
          role: t('individual_user'),
        },
      ]);
    }
  }, [data, t]);

  const config: ColumnConfig = {
    data: stats,
    xField: 'role',
    yField: 'count',
    colorField: 'role',
    paddingTop: 32,
    axis: {
      x: {
        label: {
          autoHide: true,
          autoRotate: false,
        },
      },
    },
    meta: {
      role: {
        alias: t('role'),
      },
      count: {
        alias: t('user_count'),
      },
    },
    loading,
    scale: {
      color: {
        range: ['#47DA47', '#529FF0'],
      },
    },
    label: {
      text: 'count',
      position: 'top',
      textAlign: 'center',
      dy: -15,
      style: {
        fill: 'rgba(0, 0, 0, 0.65)',
        fontFamily: 'Lufga',
      },
    },
    legend: false,
  };

  return (
    <Card
      style={{
        borderRadius: 20,
      }}
    >
      <div className="space-y-4">
        <div className="font-medium mb-4">
          {t('external_user_by_institution_affiliation')}
        </div>
        <Column key="users-by-company" {...config} />
      </div>
    </Card>
  );
};

export default UsersByCompanyAffiliation;
